import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";
import variableEffects from "@/base/global/variables/figma.effects.json";

export const tooltipThemeTokens: any = {
  colorBgSpotlight: variableColors["ColorFigmaNeutralWhiteWhite100"],
  colorTextLightSolid: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  boxShadowSecondary: variableEffects["BoxShadowElevation3"],
  fontSize: variableTypography["BodyMediumFontSize"],
  lineHeight: variableTypography["BodyMediumLineHeight"],
  borderColor: variableColors["ColorFigmaNeutralGrayscaleGray40"],
  controlHeight: 28,
  fontFamily: variableTypography["BodyMediumFontFamily"],
};
